import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pluralize',
})
export class PluralizePipe implements PipeTransform {
  transform(count: any, displayText: string): string {
    if (count != null || count != undefined) {
      return count == 1 ? displayText : displayText + 's';
    }
    return;
  }
}
